import React from "react";
import { useNavigate } from "react-router-dom";
import { useEffect , useState } from "react";
import { useLocation } from "react-router-dom";
import "./Product_extended.css";
import mutualFundsImg from "../assets/mutual_funds.jpg";
import capitalMarketImg from "../assets/capital_market.jpg";
import fixedIncomeImg from "../assets/fixed_income.jpg";
import insuranceImg from "../assets/insurance.jpg";
import realEstateImg from "../assets/real_estate.jpg";
import pmsImg from "../assets/pms.jpg";
import equityFundImg from "../assets/equity-fund.png";
import debtFundImg from "../assets/debt-fund.png";
import balancedFundImg from "../assets/balance-fund.png";
import elssFundImg from "../assets/elss-fund.png";
import smallCapFundImg from "../assets/shortterm-fund.png";
import largeCapFundImg from "../assets/longterm-fund.png";

import equities from "../assets/equities.png";
import debt_ins from "../assets/debt-instrument.png";
import pref_share from "../assets/preference-share.png";

import corporate_bonds from "../assets/corporate-bonds.png";
import treasury_bonds from "../assets/treasury-bond.png";
import certificates_deposit from "../assets/certificate-bond.png";

import life_insurance from "../assets/life-insurance.png";
import health_insurance from "../assets/health-insurance.png";
import vehicle_insurance from "../assets/car-insurance.png";
import disability_insurance from "../assets/disability-insurance.png";

import residentialProperty from "../assets/residential.png";
import commercialProperty from "../assets/commercial.png";
import industrial from "../assets/industrial.png";

import aggresive from "../assets/aggressive.png";
import defensive from "../assets//defensive.png";
import hybrid from "../assets/hybrid-fund.png";

const sections = [
  {
    title: "Mutual Funds",
    img: mutualFundsImg,
    id: "mutual-funds",
    description: `A mutual fund is a professionally managed investment fund that pools money from many investors to purchase securities. These investors may be retail or institutional in nature.\n
    Mutual funds have advantages and disadvantages compared to direct investing in individual securities. The primary advantages of mutual funds are that they provide economies of scale, a higher level of diversification, they provide liquidity, and they are managed by professional investors. On the negative side, investors in a mutual fund must pay various fees and expenses.\n 
    Primary structures of mutual funds include open-end funds, unit investment trusts, and closed-end funds. Exchange-traded funds (ETFs) are open-end funds or unit investment trusts that trade on an exchange. Some close-ended funds also resemble exchange-traded funds as they are traded on stock exchanges to improve their liquidity.`,
    items: {
      "Equity Fund": {
        img: equityFundImg,
        desc: "A private equity fund is a collective investment scheme used for making investments in various equity securities according to one of the investment strategies associated with private equity.",
      },
      "Debt Fund": {
        img: debtFundImg,
        desc: "A debt fund is an investment pool, such as a mutual fund or exchange-traded fund, in which the core holdings comprise fixed income investments.",
      },
      "Balanced Fund": {
        img: balancedFundImg,
        desc: "A balanced fund is a mutual fund that contains a stock component, a bond component, and sometimes a money market component in a single portfolio.",
      },
      "ELSS Fund": {
        img: elssFundImg,
        desc: "Many mutual fund investors are hunting for the best Equity Linked Saving Scheme or ELSSs to save taxes under Section 80C of the Income Tax Act.",
      },
      "Small Cap Fund": {
        img: smallCapFundImg,
        desc: "These mutual funds select stocks for investment from the small cap category, which includes all stocks except largest 250 stocks (by market capitalization).",
      },
      "Large Cap Fund": {
        img: largeCapFundImg,
        desc: "These mutual funds select stocks for investment from the largest 100 stocks listed in the Indian markets (highest market capitalization).",
      },
    },
  },
  {
    title: "Capital Market",
    img: capitalMarketImg,
    id: "capital-market",
    description:
      `A capital market is a financial market in which long-term debt or equity-backed securities are bought and sold. Capital markets channel the wealth of savers to those who can put it to long-term productive use, such as companies or governments making long-term investments.\n
      Capital markets are composed of primary and secondary markets. The most common capital markets are the stock market and the bond market.\n 
      Capital markets seek to improve transactional efficiencies. These markets bring those who hold capital and those seeking capital together and provide a place where entities can exchange securities.`,
    items: {
      Equities: {
        img: equities,
        desc: "An equity investment generally refers to the buying and holding of shares of stock on a stock market by individuals and firms in anticipation of income from dividends and capital gains.",
      },
      "Debt Instruments": {
        img: debt_ins,
        desc: "A debt instrument is a tool an entity can utilize to raise capital. It is a documented, binding obligation that provides funds to an entity in return for a promise from the entity to repay a lender or investor in accordance with terms of a contract.",
      },
      "Preference Share": {
        img: pref_share,
        desc: "Preference shares are shares in a company that are owned by people who have the right to receive part of the company's profits before the holders of ordinary shares are paid.",
      },
    },
  },
  {
    title: "Fixed Income",
    img: fixedIncomeImg,
    id: "fixed-income",
    description:
      `Fixed income refers to any type of investment under which the borrower or issuer is obliged to make payments of a fixed amount on a fixed schedule. For example, the borrower may have to pay interest at a fixed rate once a year, and to repay the principal amount on maturity. Fixed-income securities can be contrasted with equity securities – often referred to as stocks and shares – that create no obligation to pay dividends or any other form of income.\n 
      In order for a company to grow its business, it often must raise money – for example, to finance an acquisition; to buy equipment or land; or to invest in new product development. The terms on which investors will finance the company will depend on the risk profile of the company. The company can give up equity by issuing stock, or can promise to pay regular interest and repay the principal on the loan (bonds or bank loans). Fixed-income securities also trade differently than equities.`,
    items: {
      "Corporate Bonds": {
        img: corporate_bonds,
        desc: "A corporate bond is a bond issued by a corporation in order to raise financing for a variety of reasons such as to ongoing operations, M&A, or to expand business.",
      },
      "Treasury Bonds": {
        img: treasury_bonds,
        desc: "A Treasury bond (T-bond) is a marketable, fixed-interest U.S. government debt security with a maturity of more than 10 years.",
      },
      "Certificates of Deposit": {
        img: certificates_deposit,
        desc: "A certificate of deposit (CD) is a savings certificate with a fixed maturity date and specified fixed interest rate that can be issued in any denomination aside from minimum investment requirements.",
      },
    },
  },
  {
    title: "Insurance",
    img: insuranceImg,
    id: "insurance",
    description:
      `Insurance refers to a contractual arrangement in which one party, i.e. insurance company or the insurer, agrees to compensate the loss or damage sustained to another party, i.e. the insured, by paying a definite amount, in exchange for an adequate consideration called as premium.\n
       The insured receives a contract, called the insurance policy, which details the conditions and circumstances under which the insurer will compensate the insured. The amount of money charged by the insurer to the Policyholder for the coverage set forth in the insurance policy is called the premium.`,
    items: {
      "Life Insurance": {
        img: life_insurance,
        desc: "Life insurance is a contract between an insurance policy holder and an insurer or assurer, where the insurer promises to pay a designated beneficiary a sum of money in exchange for a premium, upon the death of an insured person.",
      },
      "Health Insurance": {
        img: health_insurance,
        desc: "Health insurance is a type of insurance coverage that covers the cost of an insured individual's medical and surgical expenses. Depending on the type of health insurance coverage, either the insured pays costs out of pocket and receives reimbursement, or the insurer makes payments directly to the provider.",
      },
      "Car Insurance": {
        img: vehicle_insurance,
        desc: "Auto insurance is a contract between you and the insurance company that protects you against financial loss in the event of an accident or theft. In exchange for your paying a premium, the insurance company agrees to pay your losses as outlined in your policy.",
      },
      "Disability Insurance": {
        img: disability_insurance,
        desc: "Disability Insurance, often called DI or disability income insurance, or income protection, is a form of insurance that insures the beneficiary's earned income against the risk that a disability creates a barrier for a worker to complete the core functions of their work.",
      },
    },
  },
  {
    title: "Real Estate",
    img: realEstateImg,
    id: "real-estate",
    description:
      `Real estate business is one of the most lucrative business in India and the second largest behind agriculture. The real estate sector can be divided into three main categories – commercial, residential and land with all sectors booming in India due to the growing middle class and foreign investment into India.\n
       Real estate is the property, land, buildings, air rights above the land and underground rights below the land. The term real estate means real, or physical, property. “Real” comes from the Latin root res, or things.`,
    items: {
      "Residential Property": {
        img: residentialProperty,
        desc: "A residential area is a land used in which housing predominates, as opposed to industrial and commercial areas. Housing may vary significantly between, and through, residential areas. These include single-family housing, multi-family residential, or mobile homes.",
      },
      "Commercial Property": {
        img: commercialProperty,
        desc: "The term commercial property refers to buildings or land intended to generate a profit, either from capital gain or rental income. Commercial property includes office buildings, medical centers, hotels, malls, retail stores, farm land, multifamily housing buildings, warehouses, and garages.",
      },
      "Industrial": {
        img: industrial,
        desc: "Industrial property is one of two subsets of intellectual property, it takes a range of forms, including patents for inventions, industrial designs, trademarks, service marks, layout-designs of integrated circuits, commercial names and designations, geographical indications and protection against unfair competition.",
      },
    },
  },
  {
    title: "PMS",
    img: pmsImg,
    id: "pms",
    description:
      `Portfolio investments are investments in the form of a group (portfolio) of assets, including transactions in equity, securities, such as common stock, and debt securities, such as banknotes, bonds, and debentures.\n
       Portfolio investment covers a range of securities, such as stocks and bonds, as well as other types of investment vehicles. A diversified portfolio helps spread the risk of possible loss because of below-expectations performance of one or a few of them.`,
    items: {
      "Aggressive": {
        img: aggresive,
        desc: "An aggressive investment strategy typically refers to a style of portfolio management that attempts to maximize returns by taking a relatively higher degree of risk.",
      },
      "Defensive": {
        img: defensive,
        desc: "A defensive investment strategy entails regular portfolio rebalancing to maintain one's intended asset allocation; buying high-quality, short-maturity bonds and blue-chip stocks; diversifying across both sectors and countries; placing stop loss orders; and holding cash and cash equivalents in down markets.",
      },
      "Hybrid": {
        img: hybrid,
        desc: "Hybrid funds offer investors a diversified portfolio. The term hybrid indicates that the fund strategy includes investment in multiple asset classes. ... Hybrid funds are commonly known as asset allocation funds.",
      },
    },
  },
];

const Product = () => {
  const navigate = useNavigate(); // Initialize the navigate function
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace("#", "");
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);
  return (
    <div className={`sections-container ${visible ? "fade-in" : ""}`}>
      {sections.map((section, index) => (
  <div key={index} className="section" id={section.title.replace(/\s+/g, "-").toLowerCase()}>
    {/* Section Header */}
    <div className="section-header row align-items-center">
      <div className="col-md-4">
        <img src={section.img} alt={section.title} className="img-fluid section-image" />
      </div>
      <div className="col-md-8">
        <h2>{section.title}</h2>
        <p>
          {section.description.split("\n").map((line, lineIndex) => (
            <React.Fragment key={lineIndex}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>
        <button className="contact-btn" onClick={() => navigate("/contact")}>
          Contact Us
        </button>
      </div>
    </div>

    {/* Section Content (Items) - Ensuring 2 Items Per Row */}
    <div className="section-content">
      <div className="row">
        {Object.keys(section.items).map((item, subIndex) => (
          <div key={subIndex} className="col-md-6">
            <div className="sub-item d-flex align-items-center">
              <img src={section.items[item].img} alt={item} className="sub-item-img me-3" />
              <div className="sub-item-text">
                <h3>{item}</h3>
                <p>{section.items[item].desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
))}

    </div>
  );
};

export default Product;
